import { useInputState } from '@mantine/hooks'
import { noop } from 'lodash'
import React, { FocusEvent, useEffect } from 'react'
import { Form, FormControlProps } from 'react-bootstrap'

import { formatDecimal } from '../Field/format'
import { parseDecimal } from '../Field/parse'

interface TDecimalInputProps
  extends Omit<FormControlProps, 'value' | 'onChange'> {
  value?: number
  onChange?: (value: number) => void
  placeholder?: string
  minimumFractionDigits?: number
}

const DecimalInput = (props: TDecimalInputProps): React.ReactElement => {
  const { value = '', onChange = noop, minimumFractionDigits, ...rest } = props

  const [inputValue, setInputValue] = useInputState('')

  useEffect(() => {
    const formatted = formatDecimal(value, minimumFractionDigits)
    if (formatted !== inputValue) {
      setInputValue(formatted)
    }
    // Fix incoming value
    const parsed = parseDecimal(formatted)
    if (parsed !== value) {
      onChange(parsed)
    }
  }, [value])

  const onBlur = (e: FocusEvent<HTMLInputElement>): void => {
    const parsed = parseDecimal(e.target.value)

    // Restore original value when invalid value was entered
    if (isNaN(parseInt(parsed?.toString() || ''))) {
      setInputValue(formatDecimal(value, minimumFractionDigits))
    } else {
      const formatted = formatDecimal(parsed ?? '', minimumFractionDigits)
      setInputValue(formatted)
      if (parsed !== value) {
        onChange(parsed)
      }
    }
  }

  const onFocus = (e: FocusEvent<HTMLInputElement>): void => {
    e.currentTarget.select()
  }

  return (
    <>
      <Form.Control
        {...rest}
        onBlur={onBlur}
        onFocus={onFocus}
        value={inputValue}
        onChange={setInputValue}
      />
    </>
  )
}

export default DecimalInput
